export default __webpack_public_path__ + "static/media/4.59f289fd.png";